var _path, _g, _path2, _g2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_289_2981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 14,
    width: 16,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14.4961H19.8399V21.8701H4V14.4961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_289_2981)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.921 15.9961C7.66 15.9961 5.5 16.7281 5.5 18.1731C5.5 19.6311 7.66 20.3701 11.921 20.3701C16.181 20.3701 18.34 19.6381 18.34 18.1931C18.34 16.7351 16.181 15.9961 11.921 15.9961ZM11.921 21.8701C9.962 21.8701 4 21.8701 4 18.1731C4 14.8771 8.521 14.4961 11.921 14.4961C13.88 14.4961 19.84 14.4961 19.84 18.1931C19.84 21.4891 15.32 21.8701 11.921 21.8701Z",
    fill: "#7A5038"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_289_2981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 12,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61035 2H17.2304V12.6186H6.61035V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_289_2981)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9214 3.428C9.78038 3.428 8.03838 5.169 8.03838 7.31C8.03138 9.444 9.76038 11.184 11.8924 11.192L11.9214 11.906V11.192C14.0614 11.192 15.8024 9.45 15.8024 7.31C15.8024 5.169 14.0614 3.428 11.9214 3.428ZM11.9214 12.619H11.8894C8.96738 12.61 6.60038 10.227 6.61038 7.307C6.61038 4.382 8.99238 2 11.9214 2C14.8494 2 17.2304 4.382 17.2304 7.31C17.2304 10.238 14.8494 12.619 11.9214 12.619Z",
    fill: "#7A5038"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7.5,
    rx: 5,
    ry: 4.5,
    fill: "#7A5038"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 18,
    rx: 7,
    ry: 3,
    fill: "#7A5038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActiveIcon);
export default __webpack_public_path__ + "static/media/profileActiveIcon.36b8c4780549d946fe959f53c0c21ff0.svg";
export { ForwardRef as ReactComponent };